<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2022-07-27 17:50:59
-->
<template>
  <el-card class="component__glossary-extractor--translation-detail">
    <p v-html="formatedSrc" class="mb-6"></p>
    <template v-if="!!detail && detail.translation">
      <p v-html="formatedTarget"></p>
    </template>
  </el-card>
</template>

<script>
const HIGHLIGHT_WORD_CLASS = "highlight-word";

function newHighWord(word) {
  const newSpan = document.createElement("span");
  newSpan.classList.add(HIGHLIGHT_WORD_CLASS);
  newSpan.appendChild(document.createTextNode(word));
  return newSpan;
}

function formatTextWithGivenWord(text, word) {
  let pos = 0;
  let pNode = document.createElement("p");
  const lowCaseText = text;
  while (pos < text.length) {
    const tPos = lowCaseText.indexOf(word, pos);
    if (tPos < 0) break;

    if (tPos > pos) {
      pNode.appendChild(document.createTextNode(text.substring(pos, tPos)));
    }
    pNode.appendChild(newHighWord(word));
    pos = tPos + word.length;
  }
  if (pos < text.length) {
    pNode.appendChild(
      document.createTextNode(text.substring(pos, text.length))
    );
  }
  return pNode.innerHTML;
}

function formatTextWithPositions(text, positions) {
  const sortedPositions = positions.sort((p1, p2) =>
    p1.start > p2.start ? 1 : p1.start < p2.start ? -1 : 0
  );
  let pNode = document.createElement("p");
  let pos = 0;
  sortedPositions.forEach((p) => {
    if (p.start > pos) {
      pNode.appendChild(document.createTextNode(text.substring(pos, p.start)));
    }
    pNode.appendChild(newHighWord(text.substring(p.start, p.end)));
    pos = p.end;
  });
  if (pos < text.length) {
    pNode.appendChild(
      document.createTextNode(text.substring(pos, text.length))
    );
  }
  return pNode.innerHTML;
}

export default {
  props: {
    detail: {
      type: Object,
      require: true,
    },
  },
  computed: {
    formatedSrc() {
      return formatTextWithGivenWord(this.detail.line.src, this.detail.src);
    },
    formatedTarget() {
      return formatTextWithPositions(
        this.detail.line.tgt,
        this.detail.translation.positions
      );
    },
  },
};
</script>

<style lang="scss">
.component__glossary-extractor--translation-detail {
  span.highlight-word {
    color: #0099ff;
  }

  p {
    margin: 0;
    line-height: 1.5;
    font-size: 14px;
    word-break: break-word;
  }
}
</style>